import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  DialogTrigger,
  makeStyles,
} from "@fluentui/react-components";
import { ArrowUploadFilled } from "@fluentui/react-icons";
import { ChangeEvent, useState } from "react";
import { FullTag, ImportTagRequest } from "../../models/VsaaTag";
import { useTagsImport } from "../../hooks/useTags";
import { ButtonWithLoading } from "../ButtonWithLoading";
import { useTranslation } from "react-i18next";

interface ExportTagsDialogProps {
  tagCollectionId: string;
}
const useStyles = makeStyles({
  triggerButton: {
    height: "33px",
    marginLeft: "8px",
    marginBottom: "5px",
  },
});

export const ImportTagsDialog = (props: ExportTagsDialogProps) => {
  const { tagCollectionId } = props;
  const { mutateAsync: importTags, isPending } = useTagsImport(tagCollectionId);

  const [tagsToImport, setTagsToImport] = useState<FullTag[]>([]);

  const classes = useStyles();
  const { t } = useTranslation();
  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (!event || !event.target.files) {
      return;
    }

    const fileReader = new FileReader();
    fileReader.readAsText(event.target.files[0], "UTF-8");
    fileReader.onload = (onLoadEvent) => {
      if (!onLoadEvent || !onLoadEvent.target) {
        return;
      }

      const content = onLoadEvent.target.result;

      if (content === null) {
        console.error("Failed to read uploaded json file.");
        return;
      }

      const json = JSON.parse(content.toString()) as ImportTagRequest;

      if (json) {
        setTagsToImport(json.tags);
        return;
      }

      console.error("Failed to parse JSON.");
    };
  };

  const onImportTagsClick = () => {
    if (!tagCollectionId || !tagsToImport || tagsToImport.length === 0) {
      return;
    }

    const request: ImportTagRequest = {
      tagCollectionId: tagCollectionId,
      tags: tagsToImport,
    };

    importTags(request);
  };

  return (
    <Dialog>
      <DialogTrigger disableButtonEnhancement>
        <Button icon={<ArrowUploadFilled />} className={classes.triggerButton}>
          {t("import")}
        </Button>
      </DialogTrigger>
      <DialogSurface aria-describedby={undefined}>
        <DialogBody>
          <DialogTitle> {t("importTags")}</DialogTitle>
          <DialogContent>
            <input type="file" onChange={handleFileChange} />
          </DialogContent>
          <DialogActions>
            <DialogTrigger disableButtonEnhancement>
              <Button appearance="secondary"> {t("close")}</Button>
            </DialogTrigger>
            <ButtonWithLoading
              text={t("import")}
              isLoading={isPending}
              disabled={
                !tagCollectionId || !tagsToImport || tagsToImport.length === 0
              }
              onClick={onImportTagsClick}
            />
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
